import Amplify from 'aws-amplify';
import awsExports from '@/aws-exports.js';

Amplify.configure(awsExports);
